<template>
  <ul class="pc-menu_box sp_none">
    <li>
      <router-link :to="{name: 'Usages'}">
        ご利用の流れ
      </router-link>
    </li>
    <li>
      <router-link :to="{name: 'About'}">
        フルーについて
      </router-link>
    </li>

    <template v-if="isLogin">
      <li v-if="isInMypage" @click="toggleMypagePcMenuCover">
        メニュー
      </li>
      <li v-else>
        <router-link :to="{name: 'MypageTop'}">
          マイページ
        </router-link>
      </li>
    </template>

    <template v-else>
      <li>
        <router-link :to="{ name: 'Login'}">
          ログイン
        </router-link>
      </li>
      <li v-if="isLoginButNotVerified">
        <button @click="resendVerifyingEmail()">
          認証メール再送信
        </button>
      </li>
      <li v-else>
        <router-link :to="{ name: 'RegistrationUser'}">
          会員登録
        </router-link>
      </li>
    </template>

    <li v-if="isLogin || isLoginButNotVerified">
      <button @click="logout()">
        ログアウト
      </button>
    </li>

    <li>
      <a target="_blank" href="https://corp.flew-createx.com/">
        <img class='base_image' src='@/assets/image/common/logo_flew_sm.png'>
      </a>
    </li>
  </ul>
</template>

<script>
  import {mapGetters} from "vuex";

  import auth from '@/assets/js/functions/firebase/auth/auth';
  import store from "@/store";

  export default {
    name: "PcMenuBox",

    mixins: [auth],

    props: {
      isInMypage: {
        type: Boolean,
      }
    },

    computed: {
      ...mapGetters({isLogin: 'auth/isLogin', isLoginButNotVerified: 'auth/isLoginButNotVerified'}),
    },

    methods: {
      toggleMypagePcMenuCover() {
        store.dispatch('cover/toggleMypagePcMenuCover')
      },
    }
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 768px) {
    .pc-menu_box {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }

    .pc-menu_box li {
      position: relative;
      transition: all .2s ease;
      margin: 0 3rem;

      > a > .base_image {
        height: 2.5rem;
      }
    }

  }
</style>
